const encoder = new TextEncoder()
const initialState = new Uint8Array(32)

export const initialIntegrityState = () => bytesToHex(initialState)

export const bytesToHex = (bytes) => Array.from(bytes)
  .map((byte) => byte.toString(16).padStart(2, '0'))
  .join('')

export const hexToBytes = (hex) => {
  if (!/^[a-f0-9]{64}$/i.test(hex ?? '')) {
    return new Uint8Array(initialState)
  }

  return new Uint8Array(hex.match(/.{2}/g).map((byte) => Number.parseInt(byte, 16)))
}

export const updateIntegrityChain = async (stateHex, chunk) => {
  const previousState = hexToBytes(stateHex)
  const chunkBytes = chunk instanceof Uint8Array ? chunk : new Uint8Array(chunk)
  const chainedBytes = new Uint8Array(previousState.byteLength + chunkBytes.byteLength)

  chainedBytes.set(previousState)
  chainedBytes.set(chunkBytes, previousState.byteLength)

  const digest = await crypto.subtle.digest('SHA-256', chainedBytes)

  return bytesToHex(new Uint8Array(digest))
}

export const fingerprintFile = async (file) => {
  const sampleSize = 64 * 1024
  const lastOffset = Math.max(0, file.size - sampleSize)
  const middleOffset = Math.max(0, Math.floor((file.size - sampleSize) / 2))
  const offsets = [...new Set([0, middleOffset, lastOffset])]
  const samples = await Promise.all(offsets.map((offset) => {
    return file.slice(offset, Math.min(file.size, offset + sampleSize)).arrayBuffer()
  }))
  const header = encoder.encode(`${file.size}:${file.lastModified}:`)
  const byteLength = samples.reduce((total, sample) => total + sample.byteLength, header.byteLength)
  const fingerprintInput = new Uint8Array(byteLength)
  let writeOffset = header.byteLength

  fingerprintInput.set(header)

  for (const sample of samples) {
    const sampleBytes = new Uint8Array(sample)
    fingerprintInput.set(sampleBytes, writeOffset)
    writeOffset += sampleBytes.byteLength
  }

  const digest = await crypto.subtle.digest('SHA-256', fingerprintInput)

  return bytesToHex(new Uint8Array(digest))
}

export const integrityStateForFileOffset = async (file, offset, chunkSize) => {
  let state = initialIntegrityState()
  let hashedOffset = 0

  while (hashedOffset < offset) {
    const nextOffset = Math.min(offset, hashedOffset + chunkSize)
    const chunk = await file.slice(hashedOffset, nextOffset).arrayBuffer()
    state = await updateIntegrityChain(state, chunk)
    hashedOffset = nextOffset
  }

  return state
}
